import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useTranslation } from 'react-i18next';
import { PURCHASE_ORDER_DETAILS, UPDATE_PURCHASE_ORDER} from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import ProductCal from '../layout/ProductCal';
import Alert from '../../../feature/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import SelectVendor from '../layout/SelectVendor';


export default function EditPurchaseOrder() {

     const [state_id, setState] = useState('');
     const [vendor_id, setVendorId] = useState('');
     const [vendor, setVendor] = useState({});
     const [errors, setErrors] = useState({});
     const [purchaseOrder, setPurchaseOrder] = useState({});
     const [products, setProducts] = useState([]);
     const [updatedProducts, setUpdatedProducts] = useState([]);
     const [customerDetails, setCustomerDetails] = useState({});
     const [notes, setNotes] = useState({});

     const { t } = useTranslation();
     const navigate = useNavigate();
     const { id } = useParams();
     const [orderDetails, setOrderDetails] = useState({prefix:'', number: '', po_date: '', valid_until: '', ref_number: '' });

     useEffect(() => {          
          getOrderDetails();
     }, [])

     const getOrderDetails = async (e) => {
          const res = await httpClient.post(PURCHASE_ORDER_DETAILS, { order_id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setVendorId(result.data.order.customer_id);
                    setPurchaseOrder(result.data.order);
                    setProducts(result.data.details);
                    setCustomerDetails(result.data.customer);
               }
          }
     }

     useEffect(() => {         
          setNotes({ terms_conditions: purchaseOrder.terms_conditions, private_notes: purchaseOrder.private_notes });
          setOrderDetails({prefix:purchaseOrder.prefix, number: purchaseOrder.po_number, po_date: purchaseOrder.po_date, valid_until: purchaseOrder.valid_until !== null ? purchaseOrder.valid_until : '', ref_number: purchaseOrder.ref_number })
       }, [customerDetails, purchaseOrder]);

     useEffect(() => {
          if (products.length > 0) {
               const data = [];
               products.map((row, index) => {
                    data.push(
                         {
                              selectedProduct: { label: row.product_name, value: row.product_id },
                              desc: row.description,
                              sac: row.sac,
                              selectedUnit: { label: row.unit_name, value: row.unit_id },
                              quantity: row.quantity,
                              price: row.price,
                              discount: row.discount,
                              discountType: row.discountType,
                              tax: row.tax,
                              total: row.net_amount,
                              stock: row.stock,
                              taxableAmount: row.taxable_amount,
                              discountAmount: row.discount_amount,
                              taxAmount: row.tax_amount
                         }
                    )
               })
               setUpdatedProducts(data);
          }

     }, [products]);
 
     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = orderDetails;
                    p['customer_id'] = vendor_id;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    p['id'] = id;
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(UPDATE_PURCHASE_ORDER, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/po');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          setState(data.state_id);
          setVendor(data.vendor);
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (vendor_id === '') {
               Alert.error("Select Vendor");
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...orderDetails };
          order[fieldName] = value;
          setOrderDetails(order);
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="edit_purchase_order" subTitle="purchase_orders" subTitleLink="root/po" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectVendor remitVendor={remitVendor} vendorId={vendor_id} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-3'>
                                        <label htmlFor='number'>{t('number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={orderDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={orderDetails.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='po_date'>{t('po_date')}</label>
                                        <input id='po_date' value={orderDetails.po_date} type='date' name='po_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_date', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='valid_until'>{t('valid_until')}</label>
                                        <input id='valid_until' value={orderDetails.valid_until} type='date' name='valid_until' className='form-control form-control-sm' onChange={(e) => handleInputChange('valid_until', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='ref_number'>{t('ref_number')}</label>
                                        <input id='ref_number' value={orderDetails.ref_number} type='text' name='ref_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('ref_number', e)} />
                                   </div>
                              </div>
                              <ProductCal title="Purchase Order" onSubmit={handelSubmit} customer={vendor} products={updatedProducts} notes={notes} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
